import type { Moment } from "moment";
import type { XYCoord } from "react-dnd";

// The drop target is the day cell under the pointer, but the event should land on the day its
// start (the dragged block's left edge) is over. Day cells in a row share the same width, so the
// day is found by how many cells the left edge sits away from the target cell.
export const getDayUnderSourceStart = (
    cellDay: Moment,
    cellElement: HTMLElement | null,
    sourceClientOffset: XYCoord | null,
): Moment => {
    const day = cellDay.clone();
    if (!cellElement || !sourceClientOffset) return day;

    const cellRect = cellElement.getBoundingClientRect();
    if (cellRect.width <= 0) return day;

    const dayOffset = Math.floor((sourceClientOffset.x - cellRect.left) / cellRect.width);
    return day.add(dayOffset, "days");
};
